import { Component, Inject, OnInit, Optional } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { IApiResult } from "src/app/shared/models/apiresult.interface";
import { forkJoin, Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { db } from "src/app/db.service";
import { DataService } from "src/app/data.service";
import "lodash";
import { NewMaterialDialogComponent } from "../material-dialog/material-dialog.component";
import { NewProductDialogComponent } from "../product-dialog/product-dialog.component";
import { ConfirmationDialogComponent } from "src/app/shared/confirmation-dialog/confirmation-dialog.component";
declare var _: any;

// string to number for formula id
// txt.match(/\d/g)

@Component({
  selector: "app-new-formula-dialog",
  templateUrl: "./formula-dialog.component.html",
  styleUrls: ["./formula-dialog.component.css"],
})
export class NewFormulaDialogComponent implements OnInit {
  formulaGroups = [];
  formulas: {
    id: string;
    productId?: number;
    includedFormulaGroupId?: number;
    quantity: number;
    price: number;
    currency: string;
    sum: number;
    type?: string;
    unit?: string;
    entryId?: number;
    name?: string;
  }[] = [];
  materialSums;
  dataLoading: boolean = false;
  formulaName: string;
  updatedMaterialPrices: { id?: number; price: number }[] = [];
  removedMaterials: {
    id: number;
    materialId?: number;
    productId?: number;
    includedFormulaGroupId?: number;
  }[] = [];
  removedMaterialFormulaIds: number[] = [];
  postedFormulaGroupId;
  formulaCost: number;
  formulaWeight: number = 0;
  selectedFormulaGroupId: number;
  selectData: {}[] = [];
  showDeleteButton: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<NewFormulaDialogComponent>,
    private http: HttpClient,
    private toastr: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: IApiResult,
    public _dataService: DataService,
    public dialog: MatDialog
  ) {}

  async ngOnInit(): Promise<void> {
    this.formulaGroups =
      this._dataService.formulaGroups() ?? (await db.formulaGroups.toArray());
    // TODO THIS ONE ONLY LOADS AFTER OPENING STOCK PAGE
    this.materialSums = JSON.parse(localStorage.getItem("groupSumData")) || [];

    this.materialSums.forEach((material) => {
      if (_.find(this._dataService.materials(), { name: material.name })) {
        _.find(this._dataService.materials(), {
          name: material.name,
        }).totalQuantity = material.totalQuantity;
      }
    });

    this._dataService.materials().forEach((material) => {
      this.selectData.push({
        ...material,
        type: "Material",
        id: material.id + "m",
      });
    });

    this._dataService.products().forEach((product) => {
      this.selectData.push({
        ...product,
        type: "Məhsul",
        id: product.id + "p",
      });
    });

    this.formulaGroups.forEach((formula) => {
      if (formula.id != this.dialogData.formulaId) {
        this.selectData.push({
          ...formula,
          type: "Formul",
          id: formula.id + "f",
        });
      }
    });

    if (this.dialogData.formulaId) {
      let selectedFormulaGroup =
        this.formulaGroups.find((f) => f.id == this.dialogData.formulaId) ??
        (await db.formulaGroups.get(this.dialogData.formulaId));
      this.formulaName = selectedFormulaGroup?.name ?? "";
      this.dataLoading = true;

      selectedFormulaGroup.formulas = selectedFormulaGroup.formulas
        .filter((f) => f.version == selectedFormulaGroup.latestVersion)
        .sort((a, b) => b.quantity - a.quantity);

      selectedFormulaGroup.formulas.forEach((e) => {
        let material = null;
        if (e.materialId != null)
          material =
            selectedFormulaGroup.materials.find((f) => f?.id == e.materialId) ??
            null;

        let type =
          e.materialId != null
            ? "material"
            : e.productId != null
            ? "məhsul"
            : "formul";
        this.formulas.push({
          entryId: e.id,
          id: e.materialId
            ? e.materialId + "m"
            : e.productId
            ? e.productId + "p"
            : e.includedFormulaGroupId + "f",
          productId: e.productId,
          type: type,
          includedFormulaGroupId: e.includedFormulaGroupId,
          quantity: e.quantity,
          price:
            e.materialId || e.productId
              ? material?.price || 1
              : e.includedFormulaGroupId
              ? this._dataService
                  .formulaGroups()
                  .find((f) => f.id == e.includedFormulaGroupId)?.cost
              : 1,
          unit: material?.unit ?? null,
          currency: "₼",
          sum:
            parseFloat((e.quantity * material?.price || 1).toFixed(3)) ?? null,
        });
      });

      this.calculateTotalPrice();

      this.showDeleteButton =
        (await db.production
          .where("formulaGroupId")
          .equals(this.dialogData.formulaId)
          .first()) ||
        this._dataService
          .formulas()
          .find((ff) => ff.includedFormulaGroupId == this.dialogData.formulaId)
          ? false
          : true;
      this.dataLoading = false;
    } else {
      this.formulas = [
        {
          id: null,
          quantity: null,
          price: null,
          unit: null,
          currency: "₼",
          sum: null,
        },
      ];
    }
  }

  addFormula(data, event) {
    event.target.innerText = "Gözləyin ...";
    event.target.disabled = true;
    this.dataLoading = true;

    let formulas: {}[] = [];
    let postFormulaGroup: Observable<any>;
    let postMaterialPriceUpdates: Observable<Object> = of(null);
    let updatedMaterialPriceIds: string = "";

    // CHECK MATERIAL PRICE UPDATES (same as before)
    this.formulas.forEach((e) => {
      if (e.id.slice(-1) == "m") {
        if (
          e.price !=
          _.find(this._dataService.materials(), { id: e.id.replace(/\D/g, "") })
            ?.price
        ) {
          this.updatedMaterialPrices.push({ price: e.price });
          updatedMaterialPriceIds += e.id.replace(/\D/g, "") + ",";
        }
      }
    });

    if (updatedMaterialPriceIds.length) {
      updatedMaterialPriceIds = updatedMaterialPriceIds.substring(
        0,
        updatedMaterialPriceIds.length - 1
      );
      postMaterialPriceUpdates = this.http.put(
        this._dataService.dbBase +
          "api.php/records/materials/" +
          updatedMaterialPriceIds,
        this.updatedMaterialPrices
      );
    }

    let formulaGroupData: any = {
      name: data.name,
      cost: this.formulaCost,
      type: this.dialogData.uzleme ? 1 : null,
    };

    let nextVersion = 1;

    if (this.dialogData.formulaId) {
      // UPDATING - increment latestVersion
      const currentGroup = _.find(this._dataService.formulaGroups(), {
        id: this.dialogData.formulaId,
      });
      nextVersion = (currentGroup?.latestVersion || 0) + 1;
      formulaGroupData.latestVersion = nextVersion;

      postFormulaGroup = this.http.put(
        this._dataService.dbBase +
          "api.php/records/formulaGroups/" +
          this.dialogData.formulaId,
        formulaGroupData
      );
    } else {
      // CREATING NEW - set latestVersion to 1
      formulaGroupData.latestVersion = 1;

      postFormulaGroup = this.http.post(
        this._dataService.dbBase + "api.php/records/formulaGroups",
        formulaGroupData
      );
    }

    postFormulaGroup
      .pipe(
        map((id) => {
          this.postedFormulaGroupId = this.dialogData.formulaId || id;

          // Prepare formulas with version
          this.formulas.forEach((f) => {
            let entryType = f.id.slice(-1);
            let baseFormula = {
              formulaGroupId: this.postedFormulaGroupId,
              quantity: f.quantity,
              version: nextVersion,
            };

            if (entryType == "m") {
              formulas.push({
                ...baseFormula,
                materialId: f.id.replace(/\D/g, ""),
              });
            } else if (entryType == "p") {
              formulas.push({
                ...baseFormula,
                productId: f.id.replace(/\D/g, ""),
              });
            } else {
              formulas.push({
                ...baseFormula,
                includedFormulaGroupId: f.id.replace(/\D/g, ""),
              });
            }
          });

          // Always add new formula entries (never update existing)
          return formulas.length > 0
            ? this.http.post(
                this._dataService.dbBase + "api.php/records/formulas/",
                formulas
              )
            : of(null);
        }),
        switchMap((postFormulas) =>
          forkJoin({
            postFormulas,
            postMaterialPriceUpdates,
          })
        )
      )
      .subscribe((res) => {
        this.dialogRef.close({
          id: this.postedFormulaGroupId,
          name: data.name,
        });
        this.toastr.success("Əlavə edildi!");
      });
  }

  getMaterialDetails(materialId, formulaId, type) {
    if (type.id && (type.id.slice(-1) == "p" || type.id.slice(-1) == "f")) {
      this.formulas[formulaId].quantity = 1;
      this.formulas[formulaId].price = 1;
    }

    if (type.id) {
      const typeLastChar = type.id.slice(-1);
      this.formulas[formulaId].type =
        typeLastChar == "p"
          ? "məhsul"
          : typeLastChar == "m"
          ? "material"
          : "formul";
    }

    if (materialId && type.id && type.id.slice(-1) == "m") {
      const material = this._dataService
        .materials()
        .find((x) => x.id == materialId.replace(/\D/g, ""));
      this.formulas[formulaId].price = material.price;
      this.formulas[formulaId].unit = material.unit;
    } else {
      this.formulas[formulaId].price = null;
      this.formulas[formulaId].unit = "əd";
    }
  }

  nextFormula() {
    this.formulas.push({
      id: null,
      quantity: null,
      price: null,
      currency: "₼",
      sum: null,
    });
  }

  removeFormula(index, formula) {
    if (formula?.entryId) {
      this.removedMaterialFormulaIds.push(formula.entryId);
    }
    this.formulas.splice(index, 1);
  }

  // TODO this needs fixing
  newFormulaDialog(formula?) {
    let dialogRef;
    let dialogType;
    if (formula.type) {
      dialogType =
        formula.type == "formul"
          ? NewFormulaDialogComponent
          : formula.type == "material"
          ? NewMaterialDialogComponent
          : NewProductDialogComponent;

      let data =
        dialogType == NewProductDialogComponent
          ? this._dataService
              .products()
              .find((x) => x.id == formula.id.replace(/\D/g, ""))
          : dialogType == NewMaterialDialogComponent
          ? this._dataService
              .materials()
              .find((x) => x.id == formula.id.replace(/\D/g, ""))
          : { formulaId: parseInt(formula.id.replace(/\D/g, "")) };
      dialogRef = this.dialog.open(dialogType, {
        width: "800px",
        data: data,
        closeOnNavigation: true,
        panelClass: "materialDialog",
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          // this._dataService.getFormulaGroups().subscribe((r) => {
          //   this._dataService.formulaGroups() = r;
          //   localStorage.setItem("formulaGroups", JSON.stringify(r));
          // });
          // this.formulaGroups = [...this.formulaGroups, res];
          // this.data.formulaGroupId = res.id;
        }
      });
    }
  }

  async getFormulaGroup(id: number) {
    let result = await db.formulaGroups.get(id);
    return result;
  }

  calculateTotalPrice(index?) {
    let totalPrice = 0;
    this.formulaWeight = 0;

    // CHECK CURRENCY TYPE
    if (index || index == 0) {
      if (this.formulas[index]?.currency == "₼") {
        this.formulas[index].sum = parseFloat(
          (this.formulas[index].quantity * this.formulas[index].price).toFixed(
            3
          )
        );
      } else {
        this.formulas[index].sum = parseFloat(
          (
            this.formulas[index].quantity *
            this.formulas[index].price *
            1.7
          ).toFixed(3)
        );
      }
    }

    this.formulas.forEach((el) => {
      if (el.currency == "₼") {
        totalPrice += el.quantity * el.price;
        totalPrice = parseFloat(totalPrice.toFixed(3));
      } else {
        totalPrice += el.quantity * el.price * 1.7;
        totalPrice = parseFloat(totalPrice.toFixed(3));
      }
      if ((el.type == "material" && el.unit == "kg") || el.type == "formul") {
        this.formulaWeight += el.quantity;
      }
      this.formulaCost = parseFloat(
        (totalPrice / this.formulaWeight).toFixed(3)
      );
    });
  }

  manatConverter(index) {
    if (this.formulas[index].currency == "₼") {
      this.formulas[index].currency = "$";
    } else {
      this.formulas[index].currency = "₼";
    }
  }

  deleteFormula() {
    let data = this.formulaName;

    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {
      width: "500px",
      data: data,
    });

    dialogRef1.afterClosed().subscribe(async (res) => {
      if (!res) return;
      this.dataLoading = true;
      this.http
        .delete(
          this._dataService.dbBase +
            "api.php/records/formulaGroups/" +
            this.dialogData.formulaId
        )
        .subscribe(async (r) => {
          this.dataLoading = false;
          if (r) {
            db.formulaGroups.delete(this.dialogData.formulaId);
            this._dataService.formulaGroups.update(
              (f) => f.id !== this.dialogData.formulaId
            );
            this.dialogRef.close();
          }
        });
    });
  }
}
